module.exports = __webpack_public_path__ + "static/img/2.c059864.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/2.png
// module id = cK4u
// module chunks = 0